var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 12C13.6363 12 9.90972 14.488 8.3999 18C9.90972 21.512 13.6363 24 17.9999 24C22.3635 24 26.0901 21.512 27.5999 18C26.0901 14.488 22.3635 12 17.9999 12ZM17.9999 22C15.5912 22 13.6363 20.208 13.6363 18C13.6363 15.792 15.5912 14 17.9999 14C20.4086 14 22.3635 15.792 22.3635 18C22.3635 20.208 20.4086 22 17.9999 22ZM17.9999 15.6C16.5512 15.6 15.3817 16.672 15.3817 18C15.3817 19.328 16.5512 20.4 17.9999 20.4C19.4486 20.4 20.6181 19.328 20.6181 18C20.6181 16.672 19.4486 15.6 17.9999 15.6Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.cf43edaae9a2f5a4e67c40c0eb15c5fb.svg";
export { ForwardRef as ReactComponent };